import "assets/scss/components/conversation/message.scss";
import React from "react";
import { useApp } from "context";
import { Helpers } from "utils";
import { Typography } from "@mui/material";

type Props = {
  time: string;
  mine: boolean;
  day: string | null;
  children: React.ReactNode;
};

export const Message = (props: Props) => {
  const { theme } = useApp();

  return (
    <div
      className={Helpers.classNames(
        "qh-conversation-message",
        props.mine && "mine",
        !props.mine && "their"
      )}
    >
      {props.day && (
        <Typography
          className="qh-day"
          sx={{
            fontSize: theme.font.xs,
            color: theme.palette.font.color,
            backgroundColor: theme.palette.background.color,
          }}
        >
          {props.day}
        </Typography>
      )}
      <div
        className="qh-content"
        style={{
          color: props.mine
            ? theme.color.primary.text
            : theme.palette.font.color,
          backgroundColor: props.mine
            ? theme.color.primary.color
            : theme.palette.background.color,
        }}
      >
        <Typography className="qh-text" sx={{ fontSize: theme.font.sm }}>
          {props.children}
        </Typography>
        <Typography className="qh-time" sx={{ fontSize: theme.font.xs }}>
          {props.time}
        </Typography>
      </div>
    </div>
  );
};
